(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Peche);

	// Constructor
	function Peche() {

		// Super constructor
		BaseGame.call(this);

		// Overide audio click sound
		this.clickSound = "audiojungle-20134560-cheeping-frog.wav";

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = false;

		this.draggable = false;

		this.user = {
			gameChoices: {
				currentQuestion: -1,
				currentState: "question",
			},
			gameFishing: {
				scores: {}
			}
		}

		this.scoreInterval = false;
		this.fishingGameRemoveFishTimeout = false;
		this.fishingGameTimeInterval = false;
		this.fishingGameEndsAt = 0;
		this.fishingGameDuration = 61;
		this.fishingGameFishesCount = 5;

		this.fishingLineOriginalPos = $("#screen-8 .fishing-line-wrapper").offset();

		// Load data then init
		this.loadData();
	}

	Peche.prototype.loadData = function () {

		// Load JSON
		$.ajax({
			url: "data/peche.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		}).promise().then($.proxy(function () {
			this.initGame();
		}, this));
	};

	Peche.prototype.initGame = function () {

		// Bind tip trigger
		$(".tip-trigger").on("click", $.proxy(this.showTip, this));

		// Go to first screen
		this.goToScreen(1);
		// this.goToScreen(5);
	};

	Peche.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		// On specific screens, make specific actions
		if (screenId == 4) {
			this.user.gameChoices.currentQuestion = -1;
		} else if (screenId == 5) {
			$("#screen-5 .game-choices-progress-inner").css('width', "4%");
			this.gameChoicesNextQuestion();
		} else if (screenId == 8) {
			this.startFishingGame();
		} else if (screenId == 10) {
			this.buildScoreScreen();
		}
	}

	Peche.prototype.gameChoicesPrevQuestion = function () {

		// This function handle back button on first game

		if (this.user.gameChoices.currentState == "question" && this.user.gameChoices.currentQuestion == 0) {
			this.goToScreen(4);
		} else if (this.user.gameChoices.currentState == "feedback") {
			// Currently on feedback screen
			this.user.gameChoices.currentQuestion -= 1;
			this.gameChoicesNextQuestion();
		} else if (this.user.gameChoices.currentState == "question") {
			// Currently on question screen
			this.user.gameChoices.currentQuestion -= 2;
			$(".game-choices-question").fadeOut("normal", $.proxy(function () {
				this.gameChoicesNextQuestion();
			}, this));
		}
	}

	Peche.prototype.gameChoicesNextQuestion = function () {

		this.user.gameChoices.currentQuestion++;
		this.user.gameChoices.currentState = "question";

		if (this.user.gameChoices.currentQuestion >= this.data["game-choices"].length) {
			this.goToNextScreen(function () {
				$(".game-choices-question").removeClass("hidden");
				$(".game-choices-freedback").addClass("hidden");
			});
			return;
		}

		$("#screen-5 .button.next").addClass("hidden");

		$(".game-choices-feedback").fadeOut("normal", function () {
			$(".game-choices-question").fadeIn("normal");
		});

		var currentQuestion = this.data["game-choices"][this.user.gameChoices.currentQuestion];
		var $gameWrapper = $("#screen-5 .choices-wrapper");
		$gameWrapper.alterClass('question-*', 'question-' + this.user.gameChoices.currentQuestion);

		var $choicesWrapper = $("#screen-5 .choices-wrapper");

		$choicesWrapper.empty();

		// Set choices
		$.each(currentQuestion.choices, $.proxy(function (i, c) {
			var $choice = $('<div class="choice"><div class="animation-wrapper"><div class="wrong-feedback"></div></div></div>');
			$choice.addClass("choice-" + c).attr("data-answer", c);
			var $choiceImg = $('<img onmousedown="return false" />');
			var fish = $(this.data["fishes"]).filterByProperty('code', c)[0];
			$choiceImg.attr("src", fish.img)
			$choice.find(".animation-wrapper").append($choiceImg);

			$choice.one("click", $.proxy(this.validateGameChoiceQuestion, this));

			$choicesWrapper.append($choice);
		}, this));

		var $questionWrapper = $("#screen-5 .question-wrapper");
		$questionWrapper.empty();

		// Set question
		var $question = $('<div />');
		$question.addClass("i18n fading-i18n");
		$question.append('<span class="fr">' + currentQuestion.question.fr + '</span>');
		$question.append('<span class="en">' + currentQuestion.question.en + '</span>');

		$questionWrapper.append($question);

		// Set tip
		var $tipWrapper = $("#screen-5 .tip-wrapper");
		this.hideTip();
		$tipWrapper.find(".tip").remove();

		var $tip = $('<div class="tip"><div class="i18n fading-i18n"></div></div>');
		$tip.find(".i18n").append('<span class="fr">' + currentQuestion.tip.fr + '</span>');
		$tip.find(".i18n").append('<span class="en">' + currentQuestion.tip.en + '</span>');

		$tipWrapper.append($tip);
		// console.log(this.data["game-choices"][this.user.gameChoices.currentQuestion]);

		// Update progress
		setTimeout($.proxy(function () {
			$("#screen-5 .game-choices-progress-inner").css('width', ((this.user.gameChoices.currentQuestion / this.data["game-choices"].length) * 94 + 4) + "%");
		}, this), 650);

	}

	Peche.prototype.validateGameChoiceQuestion = function (e) {

		var $feedbackWrapper = $("#screen-5 .game-choices-feedback");

		var userAnswer = $(e.currentTarget).data("answer");
		var currentQuestion = this.data["game-choices"][this.user.gameChoices.currentQuestion];

		if (userAnswer != currentQuestion.answer) {
			console.log("wrong");

			// Remove right class, add wrong class
			$feedbackWrapper.alterClass("right", "wrong");

			$(e.currentTarget).addClass("wrong")

			// Play audio wrong sound
			this.audio.play("audiojungle-20668144-fishing-fish-catching-with-net.wav");

		} else {

			console.log("good");

			this.user.gameChoices.currentState = "feedback";

			$(".game-choices-question").fadeOut("normal", function () {
				$(".game-choices-feedback").fadeIn("normal");
				$("#screen-5 .button.next").removeClass("hidden");
			});

			// Remove wrong class, add right class
			$feedbackWrapper.alterClass("wrong", "right");

			// Play audio good sound
			this.audio.play("audiojungle-19652630-fishing-sequence-with-water-laps.wav");

			// Remove click on all choices
			$("#screen-5 .choices-wrapper .choice").off("click");

			// Get good fish
			var fish = $(this.data["fishes"]).filterByProperty('code', currentQuestion.answer)[0];

			var $fishInfo = $feedbackWrapper.find(".fish-info");
			var $fishImage = $feedbackWrapper.find(".fish-image");
			$fishInfo.empty();
			$fishImage.empty();

			var $fishName = $('<div />');
			$fishName.addClass("fish-name i18n fading-i18n");
			$fishName.append('<span class="fr">' + fish.name.fr + '</span>');
			$fishName.append('<span class="en">' + fish.name.en + '</span>');
			if (fish.name.fr.length > 18 || fish.name.en.length > 18) {
				$fishName.addClass("long-name");
			}

			var $fishNameLatin = $('<div />');
			$fishNameLatin.addClass("fish-name-latin");
			$fishNameLatin.append('<span>' + fish.name.latin + '</span>');

			var $fishDescription = $('<div />');
			$fishDescription.addClass("fish-description i18n fading-i18n");
			$fishDescription.append('<div class="shape-before"></div><div class="shape-after"></div>');
			$fishDescription.append('<div class="fr"><span>' + fish.description.fr + '</span></div>');
			$fishDescription.append('<div class="en"><span>' + fish.description.en + '</span></div>');

			$fishInfo.append($fishName).append($fishNameLatin).append($fishDescription);

			$fishImage.append('<img class="' + currentQuestion.answer + '" src="' + fish.img + '"/>');
		}
	}

	Peche.prototype.showTip = function (e) {
		$(e.currentTarget).parent(".tip-wrapper").addClass("tip-shown");
	}

	Peche.prototype.hideTip = function (e) {
		$(".tip-wrapper").removeClass("tip-shown");
	}

	Peche.prototype.startFishingGame = function () {

		/*
		* Make them drag/droppable. If dropped on the fish line, trigger validation, then remove + spawn a new fish..
		* If dropped else where, put back in place.
		* If not dragging and was not on fish line for 10 seconds, remove it + spawn a new fish.
		* After X seconds, end game and go to next screen
		*/

		// Reset user score
		this.user.gameFishing.scores = {};

		// Make sure to stop previous games
		this.fishingGameStop(false);

		// Spawn first fishes
		for (var i = 0; i < this.fishingGameFishesCount; i++) {
			this.fishingGameSpawnFish(i);
		}

		// init draggable
		this.draggable = new Draggable.Draggable($("#screen-8").get(0), {
			draggable: '.fish.active',
			delay: 0,
		});

		this.draggable.on('drag:start', $.proxy(function (e) {
			var $el = $(e.data.originalSource);
			$el.data("timeline").pause();

			// Make sure the fish isnt scaled (by tween
			var $el2 = $(e.data.mirror);
			var matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*0,\s*0\)/;
			var matches = $el2.find("img").css('-webkit-transform').match(matrixRegex);
			var scaleX = matches[1];
			$($el, $el2).find("img").css('transform', 'scaleX(' + (scaleX / Math.abs(scaleX)) + ')');

			// Remove current feedback
			this.fishingGameRemoveFeedback($(".fish.hooked"));

		}, this));

		this.draggable.on('drag:stop', $.proxy(function (e) {
			var $el = $(e.data.originalSource);

			if (this.droppedOnFishLine(e.data.mirror)) {

				var tranform_dest = {
					left: $(e.data.mirror).offset().left + ($(e.data.mirror).width() / 2),
					top: $(e.data.mirror).offset().top
				}

				$el.css(tranform_dest);
				$el.removeClass("active").addClass("hooked")

				this.fishingGameValidateCapture($el);

				this.fishingGameRemoveFishTimeout = requestTimeout($.proxy(this.fishingGameRemoveFeedback, this, $el), 5000);

			} else {
				$el.data("timeline").play();
				this.fishingGameResetFishTimer($el);
			}
		}, this));

		this.fishingGameEndsAt = millis() + (this.fishingGameDuration * 1000);
		if (this.fishingGameTimeInterval) {
			clearInterval(this.fishingGameTimeInterval);
		}
		this.fishingGameTimeInterval = requestInterval($.proxy(this.fishingGameUpdateTimer, this), 100);
		this.fishingGameUpdateTimer();
	}

	Peche.prototype.fishingGameUpdateTimer = function () {
		var timeLeft = Math.floor((this.fishingGameEndsAt - millis()) / 1000);
		$("#fishing-timer").html(Math.max(0, timeLeft));
		if (timeLeft <= 0) {
			this.fishingGameStop(true);
		}
	}

	Peche.prototype.fishingGameSpawnFish = function (index) {
		var randomFish = this.data.fishes[window.getRandomInt(0, this.data.fishes.length - 1)];

		var fish = $("<div></div>");
		fish.append("<img src='" + randomFish.img + "'/>");

		// add random size to fish
		// Have more normal size than others
		var sizes = ["small", "normal", "large"];
		var randomSize = sizes[weightedRandom({0: 0.25, 1: 0.5, 2: 0.25})];


		fish.addClass(randomSize);
		fish.addClass("fish active");
		fish.addClass(randomFish.code);
		fish.data("fish-code", randomFish.code);

		fish.css({
			top: 50 + (index * ((1080 - 100) / this.fishingGameFishesCount)) + "px"
		})

		fish.data("index", index);

		$(".fish-tank").append(fish);

		// Set animation on the fish
		var tl = new TimelineMax({repeat: -1, paused: true});

		tl.to(fish.find("img"), 0, {scaleX: 1, immediateRender: true})
			.fromTo(fish, 5, {left: 100}, {left: 1400})
			.to(fish.find("img"), 0.25, {scaleX: -1})
			.fromTo(fish, 5, {left: 1400}, {left: 100})
			.to(fish.find("img"), 0.25, {scaleX: 1})

		tl.play(index + 3);

		fish.data("timeline", tl);

		// Set timer to handle the fish state
		this.fishingGameResetFishTimer(fish);

		fish.hide().fadeIn("normal");
	}

	Peche.prototype.fishingGameValidateCapture = function (fish) {
		var fishCode = fish.data("fish-code");
		var captureFishInfo = $(this.data["fishes"]).filterByProperty('code', fishCode)[0];


		// Check if fish has the right the be captured
		var status = false;
		if (!captureFishInfo["fishing-game"].allowed) {
			status = "not allowed";
		} else if (fish.hasClass("small")) {
			status = "too small";
		} else if (fish.hasClass("large")) {
			status = "too large";
		} else if (this.user.gameFishing.scores[fishCode] > captureFishInfo["fishing-game"].quota) {
			status = "quota exceeded";
		} else {
			status = "success";
		}

		// Increase score on success
		if (status == "success") {
			if (typeof this.user.gameFishing.scores[fishCode] === "undefined") {
				this.user.gameFishing.scores[fishCode] = 1;
			} else {
				this.user.gameFishing.scores[fishCode]++;
			}
		}

		// Play audio sound
		if (status == "success") {
			this.audio.play("audiojungle-19652630-fishing-sequence-with-water-laps.wav");
		} else {
			this.audio.play("audiojungle-20668144-fishing-fish-catching-with-net.wav");
		}

		// Show feedback
		switch (status) {
			case "success":
				// Show success popup with the fish name, and hide others
				$("#fishing-feedback").addClass("success").removeClass("error-small error-big error-quota error-not-allowed")
				break;
			case "too small":
				// Show small error popup with "too small", and hide others
				$("#fishing-feedback").addClass("error-small").removeClass("success error-big error-quota error-not-allowed")
				break;
			case "too large":
				// Show small error popup with "too big", and hide others
				$("#fishing-feedback").addClass("error-big").removeClass("success error-small error-quota error-not-allowed")
				break;
			case "quota exceeded":
				// Show big error popup with "Too many of (fish name)", and hide others
				$("#fishing-feedback").addClass("error-quota").removeClass("success error-small error-big error-not-allowed")
				break;
			case "not allowed":
				// Show big error popup with not allowed message, and hide others
				$("#fishing-feedback").addClass("error-not-allowed").removeClass("success error-small error-big error-quota ")
				break;
		}

		// Show feedback popup
		$("#screen-8 #fishing-feedback").addClass("shown");

		// Add dynamic fish names
		$("#screen-8 #fishing-feedback").find(".fr .fish-name").html(this.capitalizeFishName(captureFishInfo.name.fr));
		$("#screen-8 #fishing-feedback").find(".en .fish-name").html(this.capitalizeFishName(captureFishInfo.name.en));

		// Add fishing line hook animation
		$("#screen-8 .fishing-line-wrapper").removeClass("ready").addClass("hook-animation-out").one(window.animationEnd, $.proxy(function () {

			$("#screen-8 .fishing-line-wrapper").css({left: randomInRange(400, 1300) + "px"});

			$("#screen-8 .fishing-line-wrapper").removeClass("hook-animation-out").addClass("hook-animation-in").one(window.animationEnd, $.proxy(function () {
				$("#screen-8 .fishing-line-wrapper").off(window.transitionEnd).removeClass("hook-animation-in").addClass("ready");
			}, this));
		}, this));

	}

	Peche.prototype.capitalizeFishName = function (fishname) {
		if (fishname.startsWith("American")) {
			return fishname;
		} else {
			return fishname.charAt(0).toLowerCase() + fishname.slice(1);
		}
	}

	Peche.prototype.fishingGameClearFishTimer = function (fish) {
		if (typeof fish.data("timer") !== "undefined") {
			clearRequestTimeout(fish.data("timer"));
		}
	}

	Peche.prototype.fishingGameResetFishTimer = function (fish) {
		this.fishingGameClearFishTimer(fish);

		var timer = requestTimeout($.proxy(function (fish) {
			this.fishingGameRemoveFish(fish);
		}, this, fish), window.getRandomInt(9000, 15000));

		fish.data("timer", timer);
	}

	// Define on wich zone is dropped an item
	Peche.prototype.droppedOnFishLine = function (el) {

		if (!$("#screen-8 .fishing-line-wrapper").hasClass("ready")) {
			return false;
		}

		// Get dropped item position
		var itemPos = getPosition(el);

		var isOn = false;

		var fishLine = $("#screen-8 .fishing-line").get(0);
		var zonePosition = getPosition(fishLine);

		if (!(itemPos.translateX + $(el).width() < zonePosition.combinedX ||
			itemPos.translateX > zonePosition.combinedX + $(fishLine).width() ||
			itemPos.translateY + $(el).height() < zonePosition.combinedY ||
			itemPos.translateY > zonePosition.combinedY + $(fishLine).height())) {
			return isOn = true;
		}

		return isOn;
	}

	Peche.prototype.fishingGameRemoveFeedback = function (fish) {

		// Hide popup message
		$("#fishing-feedback").removeClass("shown");

		// Remove fish
		this.fishingGameRemoveFish(fish);

		// Clear timer
		if (this.fishingGameRemoveFishTimeout != false) {
			clearRequestTimeout(this.fishingGameRemoveFishTimeout);
		}
	}

	Peche.prototype.fishingGameRemoveFish = function (fish, replace) {
		replace = typeof replace == "boolean" ? replace : true;

		var fishIndex = fish.data("index");

		fish.removeClass("active").fadeOut("normal", $.proxy(function () {

			if (replace) {
				requestTimeout($.proxy(function () {

					if (!fish.hasClass("removed")) {
						fish.data("timeline").pause();
						fish.data("timeline").kill();
						fish.data("timeline", null);
						fish.remove();

						this.fishingGameSpawnFish(fishIndex);

						fish.addClass("removed")
					}

				}, this), 1000)
			}
		}, this))

	}

	Peche.prototype.fishingGameStop = function (goToNext) {

		// Stop timer update
		if (this.fishingGameTimeInterval != false) {
			clearRequestInterval(this.fishingGameTimeInterval);
			this.fishingGameTimeInterval = false;
		}

		// Remove all fish
		$(".fish-tank .fish").each($.proxy(function (i, n) {
			this.fishingGameRemoveFish($(n), false);
			this.fishingGameClearFishTimer($(n));
		}, this));

		// Reset draggable
		if (this.draggable != false) {
			this.draggable.destroy();
			this.draggable = false;
		}

		// reset fishing line position
		$("#screen-8 .fishing-line-wrapper").css(this.fishingLineOriginalPos).removeClass("hook-animation-out hook-animation-in");
		$("#screen-8 .fishing-line-wrapper").addClass("ready");

		if (goToNext) {
			this.goToNextScreen();
		}
	}

	Peche.prototype.buildScoreScreen = function () {

		var $screen = $("#screen-10");
		var $modelLine = $("#score-table-line-model");
		var totalFishCount = 0;

		// Remove current score lines
		$screen.find("ul.score-table li:not(:nth-child(1))").remove();

		// Create lines for wach fish
		$.each(this.data.fishes, $.proxy(function (i, n) {
			var $line = $modelLine.clone();
			$line.attr("id", "");
			$line.find(".score-table-line-name .fr").html(n.name.fr);
			$line.find(".score-table-line-name .en").html(n.name.en);
			$line.find(".score-table-line-image img").attr("src", n.img);
			var score = parseInt(this.user.gameFishing.scores[n.code]);
			score = !isNaN(score) ? score : 0;
			score = n["fishing-game"]["allowed"] == true ? score : "x";
			$line.find(".score-table-line-count").html(score);
			$screen.find("ul.score-table").append($line);
			if (score != "x") {
				totalFishCount += score;
			}
		}, this));
		
		// Add default view mode class to table
		$screen.find("ul.score-table").addClass("mode-image").removeClass("mode-name");

		// Add total score
		$screen.find(".fish-count").html(totalFishCount);

		// Handle plural form
		$screen.find(".plural").toggle(totalFishCount > 1);

		// Set final message depending on score
		if (totalFishCount >= 10) {
			$screen.find(".consigne-wrapper").addClass("score-high").removeClass("score-low score-medium");
		} else if (totalFishCount >= 5) {
			$screen.find(".consigne-wrapper").addClass("score-medium").removeClass("score-low score-high");
		} else {
			$screen.find(".consigne-wrapper").addClass("score-low").removeClass("score-medium score-high");
		}

		// Toggle between view modes
		if (this.scoreInterval != false) {
			clearInterval(this.scoreInterval);
			this.scoreInterval = false;
		}
		this.scoreInterval = setInterval($.proxy(function () {
			$screen.find("ul.score-table").toggleClass("mode-image mode-name");
		}), 4000)

	}

	Peche.prototype.goToHome = function () {
		this.reset(2)
	}

	Peche.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset(1);
		}
	}

	Peche.prototype.reset = function (destinationScreen) {

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Clear intervales
		if (this.scoreInterval != false) {
			clearInterval(this.scoreInterval);
			this.scoreInterval = false;
		}

		// Go to screen and clear
		this.goToScreen(destinationScreen, $.proxy(function () {

			// Reset and clean things up
			this.fishingGameStop(false);
			$(".game-choices-question").removeClass("hidden");
			$(".game-choices-freedback").addClass("hidden");
			this.user.gameChoices.currentQuestion = -1;
			this.user.gameChoices.currentState = "question";
			this.user.gameFishing.scores = {};

		}, this));
	}

	// Expose Peche
	window.Peche = Peche;

})(jQuery, Promise);